import { ageFromBirthdate, ADULT_AGE } from './ageGate.js'
import { parseBooleanEnvFlag } from '@/config/env.js'
import { isPasswordRecoveryRoute } from './passwordRecoveryRoutes.js'

const PROJECT_ID = String(import.meta.env?.VITE_CLARITY_PROJECT_ID || '').trim()
const IS_DEBUG = parseBooleanEnvFlag(import.meta.env?.VITE_DEBUG ?? import.meta.env?.DEBUG, false)

export const getClarityProjectId = () => PROJECT_ID

/**
 * Injeta o tag do Microsoft Clarity. Idempotente (guarda em window.clarity).
 * No-op sem project id ou fora do browser. Masking estrito é configurado no painel
 * do Clarity; regiões sensíveis também são marcadas com data-clarity-mask no DOM.
 */
export function loadClarity(projectId = PROJECT_ID) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false
  if (window.__visualgSensitiveAuthPage || isPasswordRecoveryRoute(window.location.pathname)) return false
  if (window.clarity) return true
  const id = String(projectId || '').trim()
  if (!id) return false

  window.clarity = function clarity() {
    ;(window.clarity.q = window.clarity.q || []).push(arguments)
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${id}`
  script.setAttribute('data-clarity', id)

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
  return true
}

/**
 * Clarity grava a tela do usuário (dado pessoal de alto risco). Por LGPD + ECA Digital
 * só gravamos quando há consentimento explícito de analytics E o usuário é adulto logado.
 * Menores conhecidos (15-17), crianças e anônimos (idade desconhecida) nunca são gravados.
 */
export function isClarityEligible({ consent, user, now, debug } = {}) {
  const isDebug = debug ?? IS_DEBUG
  if (isDebug) return false
  if (!consent || consent.analytics !== 'granted') return false
  if (!user) return false
  const birthdate = user.date_of_birth || user.dateOfBirth || ''
  const age = ageFromBirthdate(birthdate, now || new Date())
  if (age === null || age < ADULT_AGE) return false
  return true
}
